import { render, staticRenderFns } from "./EconomyRewards.vue?vue&type=template&id=0509862c&scoped=true&"
import script from "./EconomyRewards.vue?vue&type=script&lang=js&"
export * from "./EconomyRewards.vue?vue&type=script&lang=js&"
import style0 from "./EconomyRewards.vue?vue&type=style&index=0&id=0509862c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0509862c",
  null
  
)

export default component.exports